import React from 'react';
import './style/footer.css'
import { FaFacebookF } from 'react-icons/fa'
import { FaLinkedinIn } from 'react-icons/fa'
import { IoLogoTwitter } from 'react-icons/io'

function Footer() {
    return (
        <footer>
            <a href="#" className='footer__logo'>FALE</a>

            <ul className='permalinks'>
                <li><a href="#">Home</a></li>
                <li><a href="#about">About</a></li>
                <li><a href="#experience">Experience</a></li>
                <li><a href="#services">Services</a></li>
                <li><a href="#portfolio">Portfolio</a></li>
                <li><a href="#testimonial">Testimonial</a></li>
                <li><a href="#contact">Contact</a></li>
            </ul>

            <div className="footer__socials">
                <a href="https://www.linkedin.com/in/f%C3%A9lix-n-tougan-969331200/"><FaLinkedinIn /></a>
                <a href="https://twitter.com/Felix_Fale"><IoLogoTwitter /></a>
                <a href="https://www.facebook.com/felix.diwane.fale"><FaFacebookF /></a>
            </div>

            <div className="footer__copyright">
                <small>&copy; Fale Felix. All rights reserved.</small>
            </div>
        </footer>
    );
}

export default Footer;